
import React, { useEffect, useState } from "react";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import MobileFooter from "../components/MobileFooter";
import { IMAGE_URL, REACT_APP_API_PORT } from "../Api";
import axios from "axios";
import Loader from "../components/Loader";
import moment from "moment";
import { useParams } from "react-router";
import { Helmet } from "react-helmet";

export default function CouponPage() {
  const [copiedCode, setCopiedCode] = useState("");
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [expandedIds, setExpandedIds] = useState([]);
  const [visibleCount, setVisibleCount] = useState(6);
  const { id } = useParams();

  const fetchMetaData = async () => {
    try {
      setisLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/page-seo-details/Coupons Page`
      );
      if (res.data.status) {
        setMeta(res.data.data)

      }
    } catch (err) {
      console.error(err);
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const getData = async () => {
    try {
      setisLoading(true);
      const url = id
        ? `${REACT_APP_API_PORT}user/homepage/active-coupon-list?user_id=${id}`
        : `${REACT_APP_API_PORT}user/homepage/active-coupon-list`;
      const res = await axios.get(url);
      setData(res.data.data);
    } catch (err) {
      console.log(err);
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    fetchMetaData()
    getData();
  }, []);

  const handleCopy = (code) => {
    navigator.clipboard.writeText(code);
    setCopiedCode(code);
    setTimeout(() => setCopiedCode(""), 2000);
  };

  const toggleReadMore = (id) => {
    setExpandedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const loadMore = () => {
    setVisibleCount((prev) => prev + 6);
  };

  return (
    <>
      <Helmet>
        <title>{meta?.meta_title}</title>
        <meta name="description" content={meta?.meta_description} />
        <meta name="keywords" content={meta?.meta_keywords} />
      </Helmet>
      <Loader isLoading={isLoading} />
      <Header />
      <div className="min-h-screen bg-black text-white p-4 pt-32 md:pt-32">
        <h2 className="text-center text-4xl md:text-5xl font-bold mb-5 tracking-tight drop-shadow-[0_2px_10px_rgba(0,0,0,0.2)]">
          Available{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF]">
            Coupons
          </span>
        </h2>

        <div className="max-w-7xl mx-auto">
          {data.length === 0 && !isLoading ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <svg
                className="w-16 h-16 mb-4 text-gray-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 17v-2a4 4 0 018 0v2m1 4H6a2 2 0 01-2-2v-5a2 2 0 012-2h.586A1.5 1.5 0 007 11.5V9a5 5 0 1110 0v2.5a1.5 1.5 0 00.414 1.06H18a2 2 0 012 2v5a2 2 0 01-2 2z"
                />
              </svg>
              <p className="text-xl font-semibold mb-2">No Coupons Available</p>
              <p className="text-sm text-gray-500">
                Please check back later for new coupon offers.
              </p>
            </div>
          ) : (
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {data?.slice(0, visibleCount).map((coupon) => {
                const isExpanded = expandedIds.includes(coupon._id);
                const plainTextDescription = coupon?.description?.replace(/<[^>]+>/g, "");
                const shortText = plainTextDescription?.slice(0, 100);

                return (
                  <div
                    key={coupon._id}
                    className="bg-[#1c1c1e] border border-gray-700 rounded-2xl shadow-md p-5 hover:shadow-lg transition"
                  >

                    <div className="mb-4">
                      <img
                        src={IMAGE_URL + coupon.image || '/just-launch-default.png'}
                        onError={(e) => {
                          e.target.src = '/just-launch-default.png'
                        }}
                        className="w-full h-48 object-cover rounded-xl"
                      />
                    </div>

                    <h2 className="text-xl font-semibold text-[#00AAE6]">
                      {coupon.title}
                    </h2>

                    <p className="text-gray-300 mt-1">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: isExpanded
                            ? coupon.description
                            : shortText +
                            (plainTextDescription?.length > 100 ? "..." : ""),
                        }}
                      />
                      {plainTextDescription?.length > 100 && (
                        <button
                          onClick={() => toggleReadMore(coupon._id)}
                          className="ml-2 text-blue-400 hover:underline text-sm"
                        >
                          {isExpanded ? "Read Less" : "Read More"}
                        </button>
                      )}
                    </p>

                    <p className="text-sm text-gray-500 mt-2">
                      Valid until: {moment(coupon.valid_upto).format("LL")}
                    </p>
              


                    <div className="flex items-center justify-between mt-4">
                      <span className="text-md font-mono bg-gray-800 text-white px-3 py-1 rounded-md tracking-wider">
                        {coupon.coupon_code}
                      </span>
                      <button
                        onClick={() => handleCopy(coupon.coupon_code)}
                        className={`border border-blue-500 text-white px-4 py-1 rounded text-sm transition duration-200 hover:bg-blue-600 hover:text-white ${copiedCode === coupon.coupon_code
                          ? "bg-blue-600 text-white"
                          : ""
                          }`}
                      >
                        {copiedCode === coupon.coupon_code ? "Copied!" : "Copy Code"}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Load More Button */}
          {visibleCount < data.length && (
            <div className="flex justify-center mt-8">
              <button
                onClick={loadMore}
                className="border border-blue-500 text-white hover:bg-blue-600 hover:text-white px-6 py-2 rounded-md transition"
              >
                Load More
              </button>
            </div>
          )}
        </div>
      </div>

      <CallToAction />
      <Footer />
      <MobileFooter />
    </>
  );
}
